<template>
  <div class="category-popup-wrapper">
    <el-button
      class="dialog"
      type="text"
      @click="openPopup"
    >
      <span
        v-if="!selectedOptions"
        class="empty-input"
      >{{ $t('category.popup.select.placeholder') }}</span>
      <span v-if="selectedOptions">{{ selectedOptions }}</span>
      <i class="icon-arrow-b" />
    </el-button>
    <template v-if="!isMobile">
      <el-dialog
        class="categories"
        :title="$t('category.popup.label')"
        :visible="outerVisible"
        :modal-append-to-body="false"
        width="900px"
        center
        @close="outerVisible = false"
      >
        <el-row>
          <el-col
            v-for="categoryItem in categories"
            :key="categoryItem.id"
            :sm="8"
          >
            <el-button
              class="category-select"
              @click="categorySelect(categoryItem)"
            >
              <div class="category-icon">
                <i :class="'icon-' + categoryItem.key" />
              </div>
              <div class="category-info">
                <span class="category-name">{{ $t('category.' + categoryItem.key) }}</span>
                <span
                  v-if="categoryItem.badge"
                  class="category-badge"
                >{{ categoryItem.badge +' ads' }}</span>
              </div>
            </el-button>
          </el-col>
        </el-row>
      </el-dialog>
      <el-dialog
        class="subcategories-dialog"
        width="900px"
        :visible="innerVisible"
        :modal-append-to-body="false"
        @close="innerVisible = false"
      >
        <template v-if="innerVisible">
          <div class="subcategory-header">
            <div class="icon">
              <i :class="'icon-'+category.key" />
            </div>
            <span class="header-title">{{ $t('category.' + category.key) }}</span>
          </div>
          <el-tabs
            ref="subcategories"
            :value="subcategory ? subcategory.key : ''"
            class="subcategories"
            tab-position="top"
            @tab-click="subcategorySelect"
          >
            <el-tab-pane
              v-for="subcategoryItem in category.subcategories"
              :key="subcategoryItem.id"
              :name="subcategoryItem.key"
            >
              <span slot="label">
                <i :class="'icon-'+subcategoryItem.key" />
                {{ $t('subcategory.' + category.key + '.' + subcategoryItem.key) }}
              </span>
            </el-tab-pane>
            <category-fields
              v-model="attributeValue"
              :category="category"
              :subcategory="subcategory"
            />
          </el-tabs>
          <el-row>
            <el-col justify-content="center">
              <el-button
                class="main-large pull-right"
                @click="confirmFields()"
              >
                {{ $t('category.confirm.text') }}
              </el-button>
            </el-col>
          </el-row>
        </template>
      </el-dialog>
    </template>
    <template v-else-if="outerVisible">
      <div class="category-dropdown-wrapper">
        <span
          class="back"
          @click="confirmFields"
        />
        <div
          v-for="categoryItem in categories"
          :key="categoryItem.id"
          class="category-wrapper"
        >
          <div
            class="categories"
            @click="categorySelect(categoryItem)"
          >
            <i
              class="category-icon"
              :class="'icon-'+categoryItem.key"
            />
            <div class="content">
              <span class="name">{{ $t('category.' + categoryItem.key) }}</span>
              <!--<span class="badge">{{categoryItem.badge}} ads</span>-->
            </div>
            <div class="arrow">
              <i class="icon-arrow-b" />
            </div>
          </div>
          <template v-if="category && categoryItem.id === category.id">
            <template v-if="subcategory && !mobileFiltersVisible && category.subcategories.length">
              <!--          <template v-if="category && category.subcategories && category.subcategories.length && categoryItem.id === category.id">-->
              <!--            <template v-if="subcategory && subcategory.length && !subcategory.id && category.subcategories.length">-->
              <template v-for="subcategoryItem in category.subcategories">
                <div
                  :key="subcategoryItem.id"
                  class="subcategory"
                  :class="{make:subcategoryItem.id === subcategory.id}"
                  @click="subcategorySelectMobile(subcategoryItem)"
                >
                  <i
                    class="subcategory-icon"
                    :class="['icon-'+subcategoryItem.key]"
                  />
                  <span>{{ $t('subcategory.' + categoryItem.key + '.' + subcategoryItem.key) }}</span>
                  <div
                    :class="{ hide: subcategoryItem.id === subcategory.id }"
                    class="arrow"
                  >
                    <i class="icon-arrow-r" />
                  </div>
                </div>
                <!--<div v-if="subcategory.inner === true">-->
                <!--<div class="make-model" v-for="make in subcategory.makes" :key="make.name" @click="makeInner(make)">-->
                <!--<div>-->
                <!--<span>{{make.name }}</span>-->
                <!--<div v-if="!make.inner" class="arrow">-->
                <!--<i class="icon-arrow-r"></i>-->
                <!--</div>-->
                <!--</div>-->
                <!--<div class="models" v-if="make.inner" >-->
                <!--<div class="model" v-for="model in make.models" :key="model">-->
                <!--<span>{{model}}</span>-->
                <!--<div class="arrow">-->
                <!--<i class="icon-arrow-r"></i>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->
              </template>
            </template>
            <template v-else>
              <mobile-category-fields
                v-model="attributeValue"
                :category="category"
                :subcategory="subcategory"
                @reached-end="confirmFields"
              />
            </template>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { dataGet } from '@fps/vue-toolkit/dist/util';
  import { getFillableAttributeTypes } from '@/store/filters/filters.getters';
  import CategoryFields from './CategoryFields';
  import MobileCategoryFields from './MobileCategoryFields';

  export default {
    components: {
      CategoryFields,
      MobileCategoryFields,
    },
    // eslint-disable-next-line vue/require-prop-types
    props: ['value'],
    data() {
      return {
        outerVisible: false,
        innerVisible: false,
        attributeValue: [],
        category: null,
        subcategory: null,
        tabName: '',
        // On mobile if false shows subcategory list otherwise dynamic attribute list.
        mobileFiltersVisible: false,
      };
    },
    computed: {
      ...mapState({
        isMobile: state => state.isMobile,
        categories: state => state.temp.categories.list,
        categoryVisible: state => dataGet('temp.categories.list', state, []).reduce((o, i) => ({ ...o, [i.key]: false }), {}),
      }),
      selectedOptions() {
        return this.category ? this.$t(`category.${this.category.key}`) + (dataGet('subcategory.name', this) ?
          ` > ${this.$t(`subcategory.${this.category.key}.${this.subcategory.key}`)}` : '') : '';
      },
    },
    watch: {
      value({ category, subcategory, attributeValue }) {
        if (category !== this.category) {
          this.category = category;
          // if (this.category) {
          //   this.innerVisible = true;
          // }
        }

        if (subcategory !== this.subcategory) {
          this.subcategory = subcategory;
        }

        if (attributeValue !== this.attributeValue) {
          this.attributeValue = attributeValue;
        }
      },
      outerVisible() {
        // Reset to default value when closing
        this.mobileFiltersVisible = false;
      },
    },
    methods: {
      confirmFields() {
        const newVal = {
          attributeValue: this.attributeValue,
          category: this.category,
          subcategory: this.subcategory,
        };
        this.$emit('input', newVal);
        this.$emit('change', newVal);

        this.hidePopup();
      },
      categorySelect(category) {
        this.category = category;
        // eslint-disable-next-line no-nested-ternary
        this.subcategory = this.isMobile ? {} :
          (category.subcategories ? category.subcategories[0] : null);
        const hasSubcategories = category.subcategories && category.subcategories.length;

        // Send data and close if nothing is visible next ( no subcategory or fields )
        if (
          !hasSubcategories &&
          !getFillableAttributeTypes({ category, subcategory: this.subcategory }).length
        ) {
          this.confirmFields();
        } else {
          // Show next otherwise
          this.innerVisible = true;
          // Reset to default value when switching categories
          this.mobileFiltersVisible = !hasSubcategories;
        }
      },
      subcategorySelectMobile(subcategory) {
        this.subcategory = subcategory;
        // Disable mobile subcategory view and enable dynamic field view
        this.mobileFiltersVisible = true;

        // Send data and close if nothing is visible next ( no dynamic fields )
        if (!getFillableAttributeTypes({ category: this.category, subcategory }).length) {
          this.confirmFields();
        }
      },
      subcategorySelect(tabPane) {
        this.subcategory = this.category.subcategories ?
          this.category.subcategories[tabPane.index] :
          null;
      },
      openPopup() {
        this.outerVisible = true;
        if (this.category && this.category.subcategories.length) {
          setTimeout(() => { this.innerVisible = true; });
          // if (this.subcategory) {
          // const index = this.category.subcategories.indexOf(this.subcategory);
          // }
        }
      },
      hidePopup() {
        this.$nextTick(() => {
          this.innerVisible = false;
          this.outerVisible = false;
        });
      },
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CategoryPopup/CategoryPopup.vue